import React from 'react';
import IEmptyState from "EmptyState";
import { HorizontalAlignment } from "CommonControls/HorizontalAlignment";
import classNames from 'classnames';

interface IContactElementsProps {
    facebookPageName?: string,
    email?: string,
    phoneNumber?: string,
    address?: string,
    website?: string,
    instagramPageName?: string,
    youTubeChannelId?: string,
    lightTheme?: boolean,
    horizonalAlign?: HorizontalAlignment;
    compact?: boolean
}

export default class ContactElements extends React.Component<IContactElementsProps, IEmptyState> {
    constructor(props: IContactElementsProps) {
        super(props);
    }

    public render() {
        let className = classNames(
            "contact-elements", 
            {
                "light": this.props.lightTheme,
                "compact": this.props.compact
            },
            {
                "align-left": this.props.horizonalAlign == HorizontalAlignment.Left,
                "align-center": this.props.horizonalAlign == HorizontalAlignment.Center
            });

        return (
            <div className={className}>
                {this.props.facebookPageName &&
                    <a className="contact-element facebook underline-on-hover" href={"https://www.facebook.com/" + this.props.facebookPageName} target="_blank">
                        <img className="icon" src="img/icons/facebook.svg" />
                        <div className="text">{"fb.com/" + this.props.facebookPageName}</div>
                    </a>
                }
                {this.props.instagramPageName &&
                    <a className="contact-element facebook underline-on-hover" href={"https://www.instagram.com/" + this.props.instagramPageName} target="_blank">
                        <img className="icon" src="img/icons/instagram.svg" />
                        <div className="text">{"instagram.com/" + this.props.instagramPageName}</div>
                    </a>
                }
                {this.props.youTubeChannelId &&
                    <a className="contact-element facebook underline-on-hover" href={"https://www.youtube.com/channel/" + this.props.youTubeChannelId} target="_blank">
                        <img className="icon" src="img/icons/youtube.svg" />
                        <div className="text">{"youtu.be/channel/" + this.props.youTubeChannelId}</div>
                    </a>
                }
                {this.props.website &&
                    <a className="contact-element website underline-on-hover" href={this.props.website} target="_blank">
                        <img className="icon" src="img/icons/internet-88919E.svg" />
                        <div className="text">{this.props.website}</div>
                    </a>
                }
                {this.props.email &&
                    <a className="contact-element email underline-on-hover" href={"mailto:" + this.props.email} target="_blank">
                        {this.props.lightTheme ?
                            <img className="icon" src="img/icons/email-filled-FFFFFF.svg" />
                            :
                            <img className="icon" src="img/icons/email-filled-88919E.svg" />
                        }
                        <div className="text">{this.props.email}</div>
                    </a>
                }
                {this.props.phoneNumber &&
                    <a className="contact-element tel underline-on-hover" href={"tel:" + this.props.phoneNumber.replace("poste", ",")} target="_blank">
                        <img className="icon" src="img/icons/phone-filled-1472BA.svg" />
                        <div className="text">{this.props.phoneNumber}</div>
                    </a>
                }{
                    this.props.address &&
                    <a className="contact-element address underline-on-hover" href={"http://maps.google.com/?q=" + this.props.address} target="_blank">
                        <img className="icon" src="img/icons/map-marker-filled-8F231F.svg" />
                        <div className="text">{this.props.address}</div>
                    </a>
                }
            </div>
        );
    }
}